<template>
  <v-card elevation="0"> 
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
      <v-row class="ma-0">
        <div>
          <v-btn @click="createProjectTask" color="primary">
            <v-icon class="mr-2">mdi-plus</v-icon>
            {{ languageData.btnAddProjectTask }}
          </v-btn>
        </div>
      </v-row>
    <v-row class="row justify-center">
      <v-col class="col-12 col-xl-9">
        <ProjectTasksTable></ProjectTasksTable>
      </v-col>
    </v-row>

    <ModalInfo :layout="'modalForm'" :scrollable="true" :hidden-agree-btn="true" @clicked="hideModalProjectTaskForm" :show-modal="isShowProjectTaskFormModal">
      <template v-slot:body>
        <ProjectTasksForm :layout="projectTasksFormModalLayout"></ProjectTasksForm>
      </template>
    </ModalInfo>
  </v-card>
</template>




<script type="text/javascript">
import { mapActions, mapState } from "vuex";
import eventBus from "../../../event-bus/eventBus";
import ProjectTasksForm from "./ProjectTasksForm";
import ProjectTasksTable from "./ProjectTasksTable";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";

export default {
  name: "ProjectTasks",
  components: {
    ProjectTasksForm,
    ProjectTasksTable,
    ModalInfo
  },
  data() {
    return {
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      }
    }
  },
  computed: {
    ...mapState("updateVisibleProjectTaskModal", {
        isShowProjectTaskFormModal: state => state.isShowProjectTaskFormModal,
        projectTasksFormModalLayout: state => state.layout
    }),
  },
  methods: {
    getSnackbarSuccess: function(title, message, top = false) {
      this.snackbar = {
        color: "success",
        icon: "check_circle",
        mode: "multi-line",
        position: top,
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
    ...mapActions("updateVisibleProjectTaskModal", ["updateVisibleProjectTaskFormModal"]),
     ...mapActions("saveProjectEntry", ["storeProjectEntry"]),

    hideModalProjectTaskForm: function() {
      this.updateVisibleProjectTaskFormModal(false);
    },
    createProjectTask: function() {
      this.updateVisibleProjectTaskFormModal(true);
      eventBus.$emit("clearProjectTaskFormModal");
    }
  },
  mounted() {
    eventBus.$on("deleteProjectTaskSuccess", (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
    });
    eventBus.$on("updateProjectTaskSuccess", (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      this.updateVisibleProjectTaskFormModal(false);
    });
    eventBus.$on("saveProjectTaskSuccess", (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message, true);
      this.task = {
        title: '',
        description: '',
        status: 0
      };
      eventBus.$emit("getProjectTasks");
      this.updateVisibleProjectTaskFormModal(false);
    });
  }
}
</script>